// IdbHealthWatcher — one-time probe of IndexedDB availability + sticky-toast
// notification when degraded.
//
// Decision (Session 19AT · S2):
//   IndexedDB failure modes (Safari Private Mode, full disk, blocked upgrade)
//   currently surface as console errors only — user sees nothing, then
//   silently loses everything they typed. This component runs once on mount,
//   probes IDB, and posts a sticky error toast if unavailable.
//
// Mounted from App root inside ToastProvider so toast() is in scope.

import { useEffect } from 'react';
import { listDrafts } from '../storage/idb.js';
import { useToast } from './toast.js';
import { useT } from '../i18n/index.js';

let _probed = false;

export function IdbHealthWatcher() {
  const toast = useToast();
  const t = useT();
  useEffect(() => {
    if (_probed) return;
    _probed = true;
    // Use listDrafts as the probe — it's a read on a guaranteed-existing
    // store, so success means open + transaction both work.
    listDrafts().catch((err: Error) => {
      toast.error(t('idbHealth.unavailable'), { sticky: true });
      // eslint-disable-next-line no-console
      console.warn('[IdbHealthWatcher] probe failed:', err);
    });
  }, [toast, t]);
  return null;
}
